<template>
<div>
    <Breadcrumbs main="Admin" title="Changemaker View" />
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div style="position: relative; width: 100%; border-radius: 1rem; overflow: hidden; box-shadow: 0 1px 4px rgba(0,0,0,0.08);">
                    <!-- Banner -->
                    <div style="width: 100%;">
                        <img v-if="changemaker_view?.banner" :src="changemaker_view?.banner" style="width: 100%; object-fit: cover; min-height: 200px; max-height: 350px;" alt="banner" />
                        <!-- <img v-else src="../../assets/images/profile.png" style="height: 100%; width: 100%; object-fit: cover;" alt="default banner" /> -->
                    </div>

                    <!-- Avatar -->
                    <div style="position: absolute; bottom: 1rem; left: 1rem;">
                        <div>
                            <img v-if="changemaker_view?.logo" :src="changemaker_view?.logo" style="height: 6rem; width: 6rem; border-radius: 1rem; border: 4px solid white; object-fit: cover; box-shadow: 0 1px 4px rgba(0,0,0,0.08);" alt="avatar" />
                            <!-- <img v-else src="../../assets/images/cover.png" style="height: 6rem; width: 6rem; border-radius: 1rem; border: 4px solid white; object-fit: cover; box-shadow: 0 1px 4px rgba(0,0,0,0.08);" alt="default avatar" /> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" style="margin-top: 30px;">
            <div class="col-md-5">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12">
                                <div>
                                    <h7 style="color: gray;">Name</h7>
                                    <h6 v-if="changemaker_view?.name" style="margin-top: 2px;">{{ changemaker_view?.name }}</h6>
                                    <div v-else>
                                        <h6>N/A</h6>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 mt-2">
                                <div>
                                    <h7 style="color: gray;">Changemaker Id</h7>
                                    <h6 v-if="changemaker_view?.id" style="margin-top: 2px;">{{ changemaker_view?.id }}</h6>
                                    <div v-else>
                                        <h6>N/A</h6>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 mt-2">
                                <div>
                                    <h7 style="color: gray;">Address</h7>
                                    <h6 v-if="changemaker_view?.address" style="margin-top: 2px;">{{ changemaker_view?.address }}</h6>
                                    <div v-else>
                                        <h6>N/A</h6>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 mt-2">
                                <div>
                                    <h7 style="color: gray;">Category</h7>
                                    <h6 v-if="changemaker_view?.category" style="margin-top: 2px; text-transform: uppercase;">{{ changemaker_view?.category }}</h6>
                                    <div v-else @click="updateToggle(changemaker_view?.id)" style="cursor: pointer;">
                                        <b-badge variant="danger">Pending</b-badge>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 mt-2">
                                <div>
                                    <h7 style="color: gray;">Applied</h7>
                                    <h6 v-if="changemaker_view?.created_at" style="margin-top: 2px;">{{ changemaker_view?.created_at }}</h6>
                                    <div v-else>
                                        <h6>N/A</h6>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 mt-2">
                                <div>
                                    <h7 style="color: gray;">Status</h7>
                                    <div v-if="changemaker_view?.verification_status == 'verified'" @click="updateToggle(changemaker_view?.id)" style="cursor: pointer;">
                                        <b-badge variant="success">Verified</b-badge>
                                    </div>
                                    <div v-else @click="updateToggle(changemaker_view?.id)" style="cursor: pointer;">
                                        <b-badge variant="danger">Pending</b-badge>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mt-3" style="margin-left: -14px;">
                            <div class="col-sm-12">
                                <div>
                                    <h7 style="color: gray;">Number of Employees</h7>
                                    <h6 v-if="changemaker_view?.number_of_employee" style="margin-top: 2px;">{{ changemaker_view?.number_of_employee }}</h6>
                                    <div v-else>
                                        <h6>N/A</h6>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 mt-3">
                                <div>
                                    <h7 style="color: gray;">Registered</h7>
                                    <div style="margin-top: 2px;">
                                        <b-badge v-if="changemaker_view?.registration == true" variant="success">Yes</b-badge>
                                        <b-badge v-else variant="danger">No</b-badge>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 mt-3">
                                <div>
                                    <h7 style="color: gray;">Website</h7>
                                    <h6 v-if="changemaker_view?.website" style="margin-top: 2px;">
                                        <a :href="changemaker_view?.website" target="_blank" rel="noopener noreferrer">
                                            {{ changemaker_view?.website?.slice(0, 50) }}
                                        </a>
                                    </h6>
                                    <div v-else>
                                        <h6>N/A</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-7">
                <div class="card">
                    <div class="card-body">
                        <div>
                            <h7 style="color: gray;">About Changemaker</h7>
                            <div v-if="changemaker_view?.bio" style="margin-top: 4px;" v-html="changemaker_view?.bio"></div>
                            <div v-else>
                                <h6>N/A</h6>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12">
                                <div>
                                    <h7 style="color: gray;">Impact Domains</h7>
                                    <div v-if="changemaker_view?.impact_domains && changemaker_view?.impact_domains?.length > 0" style="display: flex; flex-wrap: wrap; gap: 4px; margin-top: 4px;">
                                        <div v-for="interest in changemaker_view?.impact_domains">
                                            <b-badge variant="info" style="text-transform: capitalize;">{{ interest }}</b-badge>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <h6>N/A</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-sm-12">
                                <div>
                                    <h7 style="color: gray;">Geographic Area of Operations</h7>
                                    <div v-if="changemaker_view?.geographic_area_of_operations && changemaker_view?.geographic_area_of_operations?.length > 0" style="display: flex; flex-wrap: wrap; gap: 4px; margin-top: 4px;">
                                        <div v-for="interest in changemaker_view?.geographic_area_of_operations">
                                            <b-badge variant="info" style="text-transform: capitalize;">{{ interest }}</b-badge>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <h6>N/A</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-sm-12">
                                <div>
                                    <h7 style="color: gray;">Interest in Joining</h7>
                                    <div v-if="changemaker_view?.interest_in_joining && changemaker_view?.interest_in_joining?.length > 0" style="display: flex; flex-wrap: wrap; gap: 4px; margin-top: 4px;">
                                        <div v-for="interest in changemaker_view?.interest_in_joining">
                                            <b-badge variant="info" style="text-transform: capitalize;">{{ interest }}</b-badge>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <h6>N/A</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-sm-12">
                                <div>
                                    <h7 style="color: gray;">Contact</h7>
                                    <div v-if="changemaker_view?.contact && changemaker_view?.contact?.length > 0" style="display: flex; flex-wrap: wrap; gap: 20px; margin-top: 4px;">
                                        <div v-for="contact in changemaker_view?.contact">
                                            <div class="p-2" style="border: 1px solid lightgray; border-radius: 8px; min-width: 200px;">
                                                <div>{{ contact.name }}</div>
                                                <div>{{ contact.email }}</div>
                                                <div>{{ contact.phone }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <h6>N/A</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-sm-12">
                                <div>
                                    <h7 style="color: gray;">Members</h7>
                                    <div v-if="changemaker_view?.members && changemaker_view?.members?.length > 0" style="display: flex; flex-wrap: wrap; gap: 20px; margin-top: 4px;">
                                        <div v-for="contact in changemaker_view?.members">
                                            <div class="p-2" style="border: 1px solid lightgray; border-radius: 8px; min-width: 200px;">
                                                <div v-if="contact.user?.first_name">Name: {{ contact.user?.first_name }} {{ contact.user?.last_name }}</div>
                                                <div v-if="contact.user?.email">Email: {{ contact.user?.email }}</div>
                                                <div v-if="contact.user?.profile_info?.phone_number">Phone: {{ contact.user?.profile_info?.phone_number }}</div>
                                                <div v-if="contact.role && contact.role == 'admin'">Role: <b-badge variant="info" style="text-transform: capitalize;">{{ contact.role }}</b-badge>
                                                </div>
                                                <div v-if="contact.role && contact.role !== 'admin'">Role: <b-badge variant="primary" style="text-transform: capitalize;">{{ contact.role }}</b-badge>
                                                </div>
                                                <div v-if="contact.assigned_date">Assigned Date: {{ contact.assigned_date }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <h6>N/A</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import {
    myHost
} from '../../_helpers/host'

export default {

    data() {
        return {
            host: myHost.host,
            changemaker_view: null
        };
    },

    computed: {
        ...mapState({
            items: state => state.changemaker.changemakerDetails,
            loading: state => state.changemaker.changemakerLoading,
            error: state => state.changemaker.changemakerError
        })
    },

    watch: {
        items(oldValue, newValue) {
            this.changemaker_view = this.items
        }
    },

    mounted() {
        this.$store.dispatch('changemaker/fetchChangemakerDetails', this.$route.params.id).then(() => {
            this.changemaker_view = this.items
        });
    },

    methods: {
        updateToggle(id) {
            this.$store.dispatch('changemaker/updateStatusToggle', {
                changemaker_id: id
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: 'Success!',
                        text: response.response,
                        icon: 'success'
                    });
                } else {
                    Swal.fire({
                        title: 'Error!',
                        text: response.response,
                        icon: 'error'
                    });
                }
            });
        }
    }
};
</script>

<style scoped></style>
